import dayjs, { type Dayjs } from 'dayjs'

import type { TDateArg } from '../primitives/dates/date.types'

const removeTimeZone = (date?: TDateArg | null) => {
  try {
    if (!date) return undefined
    let dateString: string
    if (typeof date === 'string') {
      dateString = date
    } else if (typeof date === 'number') {
      dateString = new Date(date).toISOString()
    } else {
      dateString = date.toISOString()
    }
    return new Date(dateString.split('T')[0])
  } catch (_) {
    return undefined
  }
}
export const getDateWithoutTimezone = (date?: TDateArg | null | ''): Dayjs | undefined => {
  try {
    if (!date) return undefined
    const dateWithoutTimezone = removeTimeZone(date)
    return dayjs.utc(dateWithoutTimezone).locale(dayjs().locale()) // restore locale after utc
  } catch (_) {
    return undefined
  }
}
